// extracted by mini-css-extract-plugin
module.exports = {"subtleText":"ActivityTable-module__subtleText--bSGF4","arrowHidden":"ActivityTable-module__arrowHidden--1FLYU"};